<template>
	<div>
		<Modal v-model="modal1" :mask-closable="false" :class-name="wTheme" :width="width" @on-cancel="cancel" class="ws-modal">
			<div slot="header" class="modal-header">
        <span class="sigma-box_zi">{{title}}</span>
        <!-- <div class="sigma-box" style="margin: 13px auto;">
          <div class="signa_line">
            <span class="xian"></span>
            
            <span class="sigma-box_zi">{{title}}</span>
            
            <span class="xian" style="margin-left: -4px;"></span>
          </div>
        </div> -->
				<!--<Icon type="information-circled"></Icon>-->
				<!--<span>{{title}}</span>-->
			</div>
			<div class="modal-body">
				<slot></slot>
			</div>
			<div slot="footer" class="modal-bottom">
				<Button v-if="whetherShowCancel" @click="cancel">{{cancelText}}</Button>
				<Button v-if="whetherShowButton" @click="btnok">{{btnText}}</Button>
				<Button v-if="whetherShowBottom" @click="btnBottom">{{bottomText}}</Button>
				<Button type="primary"  v-if="whetherShowOk" @click="ok">{{okText}}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import $ from 'jquery';
	import m from 'malihu-custom-scrollbar-plugin';
	import mw from 'jquery-mousewheel';
	import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
	export default {
		props: {
			value: {
				required: true,
				default: null
			},
			btnText: {
				type: String,
				default: '确认'
			},
			okText: {
				type: String,
				default: '确认'
			},
			cancelText: {
				type: String,
				default: '取消'
			},
			bottomText: {
				type: String,
				default: '再来一单'
			},
			title: {
				type: String
			},
			width: {
				type: Number
			},
			//是否展示ok按钮
			whetherShowOk: {
				type: Boolean,
				default: true
			},
			//是否展示cancel按钮
			whetherShowCancel: {
				type: Boolean,
				default: false
			},
			
			whetherShowBottom:{
				type: Boolean,
				default: false
			},
			whetherShowButton:{
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				modal1: false,
				modalId: ''
			}
		},
		watch: {
			value(val) {
				this.modal1 = val;
				if(val) {
					//显示的时候才触发
					this.modalId =  'ws-modal-' + Date.parse(new Date());
					this.init();
				}
			},
			modal1(val) {
				this.$emit('input', val);
			}
		},
		computed: {
			/**
			 * 系统皮肤
			 * @return {[type]} [description]
			 */
			wTheme() {
				return 'ws-modal ' + this.modalId;
			}
		},
		mounted() {},
		methods: {
			//初始化
			init() {
				var obj = this;
				this.$nextTick(function() {
					this.bindScroll();
					$(window).resize(function() {
						obj.bindScroll();
					});
				});
			},
			bindScroll() {
				let pModalId = '.' + this.modalId;
				let windowHeight = $(window).height();
				let modalHeight1 = $(pModalId + ' .ivu-modal-body .modal-body').height();
				let modalHeight2 = $(pModalId + ' .ivu-modal-body').height();
//				console.log(pModalId + '-----' +modalHeight1 + '---' + modalHeight2);
				let realHeight = modalHeight1 + 100 + 50.71 + 55.8 + 55.98;
				if(realHeight > windowHeight) {
					let r1Height = realHeight - 100;
					let top = 0;
					if(r1Height > windowHeight) {
						//需要出现滚动条
						let r2Height = windowHeight - 50.71 - 55.8 - 33;
						$(pModalId + ' .ivu-modal .ivu-modal-content .ivu-modal-body').height(r2Height);
						$(pModalId + ' .ivu-modal .ivu-modal-content .ivu-modal-body').mCustomScrollbar({
							theme: "minimal-dark",
							scrollInertia: 500
						});
					} else {
						top = (windowHeight - r1Height) / 2;
					}
					$(pModalId + ' .ivu-modal').css('top', top + 'px');
				} else {
				}
			},
			//确认按钮触发
			ok() {
				this.$emit('on-ok');
			},
			//取消按钮触发(包含关闭图标)
			cancel() {
				this.$emit('on-cancel');
			},
			
			btnBottom(){
				this.$emit('on-btn-bottom');
			},
			btnok(){
				this.$emit('on-btn-ok');
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.wsplus-theme-light .ivu-modal .ivu-modal-content .ivu-modal-close .ivu-icon {
		color: #FFFFFF;
	}
	
	>>>.ivu-modal-close {
		top: 4px !important;
	}
	
	>>>.sigma-box_zi {
		display: inline-block;
		vertical-align: middle;
	}

	.wsplus-theme-dark .ivu-modal .ivu-modal-content .ivu-modal-close .ivu-icon {}
	/**
	 * 顶部
	 */

	.ws-modal .ivu-modal .ivu-modal-content .ivu-modal-header {}

	.wsplus-theme-light .ivu-modal .ivu-modal-content .ivu-modal-header {
		background-color: #1e88e5 !important;
		/*#2d8cf0;*/
	}

	.wsplus-theme-dark .ivu-modal .ivu-modal-content .ivu-modal-header {
		background-color: #f3f3f3;
	}

	.ws-modal .ivu-modal .ivu-modal-content .ivu-modal-header .modal-header {
		text-align: center;
	}

	.wsplus-theme-light .ivu-modal .ivu-modal-content .ivu-modal-header .modal-header {
		color: #FFFFFF;
	}

	.wsplus-theme-dark .ivu-modal .ivu-modal-content .ivu-modal-header .modal-header {}
	/**
	 * 内容体
	 */

	.ws-modal .ivu-modal .ivu-modal-content .ivu-modal-body {
		/*height: 364px;*/
	}

	.ws-modal .ivu-modal .ivu-modal-content .ivu-modal-body .modal-body {}
	/**
	 * 底部
	 */

	.ws-modal .ivu-modal .ivu-modal-content .ivu-modal-footer {}



	.ws-modal .ivu-modal .ivu-modal-content .ivu-modal-footer .modal-bottom .ivu-btn {
		padding-left: 25px;
		padding-right: 25px;
	}
</style>



// WEBPACK FOOTER //
// src/components/modal/src/index.vue